import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { AppointmentUiComponent } from '../appointment-ui/appointment-ui.component';
import { NurseDashboardService } from './nurse-dashboard.service';
import { commonImports } from '../shared/table-interface';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DoctorDashboardService, DashboardTaskSummary } from '../doctors-dashboard/doctor-dashboard.service';
import { ReferenceDisplayDirective } from '../shared/reference-display.directive';
import { ScrolldDirective } from '../scrolld.directive';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AsyncPipe, DatePipe } from '@angular/common';
import { UpcomingActivitiesComponent } from '../unified-activities/upcoming-activities.component';

@Component({
  selector: 'app-nurse-dashboard',
  imports: [...commonImports, AppointmentUiComponent,UpcomingActivitiesComponent, ReferenceDisplayDirective, ScrolldDirective, MatIconModule, MatTooltipModule, AsyncPipe, DatePipe],
  templateUrl: './nurse-dashboard.component.html',
  styleUrls: ['../admin-dashboard/admin-dashboard.component.scss', './nurse-dashboard.component.scss']
})
export class NurseDashboardComponent implements OnInit {
  private nurseService = inject(NurseDashboardService);
  private dashboardService = inject(DoctorDashboardService);
  private router = inject(Router);
  private cd = inject(ChangeDetectorRef);

  vitalsPending$: Observable<number> = this.nurseService.getVitalsPendingCount$();
  bedOccupancy$: Observable<number> = this.nurseService.getBedOccupancyCount$();
  pendingMedTasks$: Observable<number> = this.nurseService.getPendingMedicationTasksCount$();
  nextTasks$: Observable<DashboardTaskSummary[]> = this.dashboardService.getNextTasksForCurrentUser$(3);

  ngOnInit(): void {
    // Initial data load already handled by observables
  }

  navigateToVitals(): void {
    this.router.navigate(['/app/service-requests/observation']);
  }

  navigateToAdmittedPatients(): void {
    this.router.navigate(['/app/admitted-patients']);
  }

  navigateToMedicationRequests(): void {
    this.router.navigate(['/app/medicine-requests']);
  }

  navigateToTasks(): void {
    this.router.navigate(['/app/tasks']);
  }
}
